import 'leaflet/dist/leaflet.css';
import { useEffect, useState } from 'react';
import { CircleMarker, MapContainer, Popup, TileLayer } from 'react-leaflet';
import './Eventmap.css'; // Import your CSS file here
import axios from 'axios';
import { GET_ALL_EVENT_BY_FAMILY, GET_ALL_EVENT_BY_FAMILY_SUGGESTED } from '../ApiDetails.js';

const EventMap = ({ filters, selectedRegion, selectedYear }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userLocation = { lat: 51.505, lng: -0.09 }; // Replace with the actual user's location
    const bounds = [
        [-85, -180], // Southwest corner
        [85, 180], // Northeast corner
    ];

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const [familyResponse, suggestedResponse] = await Promise.all([
                    axios.get(GET_ALL_EVENT_BY_FAMILY),
                    axios.get(GET_ALL_EVENT_BY_FAMILY_SUGGESTED)
                ]);

                if (familyResponse.status != 200 || suggestedResponse.status != 200) {
                    throw new Error('Network response was not ok');
                }

                // Combine both sets of events
                setEvents([...familyResponse.data, ...suggestedResponse.data]);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, []);

    const getFillColor = (event) => {
        if (filters.myEvents && event.category === 'myEventDtos' && event.hasInvitation) {
            return 'lime';
        }
        if (filters.otherFamilyEvents && event.category === 'otherFamilyEventDtos' && event.familyHasInvitation) {
            return 'yellow';
        }
        if (filters.needsFamilyMembers && event.category === 'needFamilyMemberDtos') {
            return 'red';
        }
        return null; // Exclude events that don't match any specific filter
    };

    const filteredEvents = events.filter(event => {
        const fillColor = getFillColor(event);
        const regionMatch =
            selectedRegion === '' || (event.region && event.region.toLowerCase() === selectedRegion.toLowerCase());

      const yearMatch =
            selectedYear === null ||
            new Date(event.eventDate).getFullYear() === selectedYear ||
            new Date(event.eventDate).getFullYear() === (selectedYear + 1);
        return fillColor !== null && event.lat !== 0 && event.lng !== 0 && regionMatch && yearMatch;
    });

    if (loading) return <p>Loading events...</p>;
    if (error) return <p>Error fetching events: {error}</p>;

    return (
        <MapContainer center={userLocation}
            zoom={4}
            maxZoom={10}
            minZoom={1}
            maxBounds={bounds}
            style={{ height: '100%' }}
        >
            <TileLayer
                url="http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            />
            {filteredEvents.map(event => ( ((event.lat !== 0) || (event.lng !== 0 )) ? (
                <CircleMarker
                    key={event.id}
                    center={[event.lat, event.lng]}
                    color={getFillColor(event)}
                    fillColor={getFillColor(event)}
                    fillOpacity={1}
                    radius={10}
                    className="custom-circle-marker" // Applying the CSS class for the border
                >
                    <Popup>{event.name}</Popup>
                </CircleMarker>
            ) : ""))}
        </MapContainer>
    );
};

export default EventMap;
